import documentDetailsActionCreators from "Areas/Documents/documentDetails/redux/actionCreators";
import tableActionCreators from "Areas/Documents/table/redux/actionCreators";
import { getDocumentTableDataInProgress } from "Areas/Documents/table/redux/selectors";
import { getActiveDocumentId } from "Areas/Sidebar/Documents/redux/selectors";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getGroupData, getGroupNodesTableModalState } from "../redux/selectors";
import { GroupNodeTable } from "./groupNodeTable";
const mapStateToProps = (state) => ({
    groupData: getGroupData(state),
    isOpen: getGroupNodesTableModalState(state),
    documentId: getActiveDocumentId(state),
    inProgress: getDocumentTableDataInProgress(state)
});
const mapDispatchToProps = (dispatch) => ({
    onGetTableData: (documentId, nodeIds, completed) => dispatch(tableActionCreators.getDocumentTableData(documentId, undefined, nodeIds, completed, false)),
    onClose: () => dispatch(actionCreators.setTableModalState(false)),
    onGetPreview: (largeAttributeId, completed, rejected) => dispatch(documentDetailsActionCreators.getGraphNodeImageContent(largeAttributeId, completed, rejected))
});
export default connect(mapStateToProps, mapDispatchToProps)(GroupNodeTable);
